import Valkyrie, { viArrowsRotateRight } from "@sippy-platform/valkyrie";

import { Alert, AlertTitle, Button, Link, Typography } from "@mui/material";

function ErrorMessage() {
  return (
    <Alert severity="error">
      <AlertTitle>Something went wrong</AlertTitle>
      <Typography>
        Something stopped us from properly showing this area. This may be the result of a bad internet connection, an
        incorrect URL, or a crash in Sippy. You can check if Sippy is experiencing issues at{" "}
        <Link target="_blank" href="https://status.sippy.cloud">
          our status page
        </Link>
        .
      </Typography>
      <Button
        variant="contained"
        sx={{ mt: 2, mr: 1 }}
        startIcon={<Valkyrie icon={viArrowsRotateRight} />}
        onClick={() => window.location.reload()}
      >
        Refresh
      </Button>
    </Alert>
  );
}

export default ErrorMessage;
